import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { SiteMapUrl } from 'src/app/core/_enums/sitemap.url';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { Mail } from 'src/app/core/_models/mail';
import { User } from 'src/app/core/_models/user';
import { UserRight } from 'src/app/core/_models/userRight';
import { AuthService } from 'src/app/core/_services/auth.service';
import { MailService } from 'src/app/core/_services/mail.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { UserService } from 'src/app/core/_services/user.service';
import { UpdateResourceAction } from 'src/app/store/actions/resource.actions';
import { AppState } from 'src/app/store/app.state';
import { environment } from 'src/environments/environment';
import { DialogOverviewComponent } from '../shared/dialog-overview/dialog-overview.component';
import { DialogRightUserComponent } from '../shared/dialog-right-user/dialog-right-user.component';
import { MailTemplates } from 'src/app/core/_enums/mailtemplates';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  form!: FormGroup;
  perimeterId!: string;
  userRights!: UserRight[];
  currentItem?: User;
  listRecipient = ['seve@seve-tp.com'];
  formSign!: FormGroup;
  mailContent!: string;
  mailInit: boolean;

  constructor(
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private dialog: MatDialog,
    private router: Router,
    private snackbarService: SnackbarService,
    private authService: AuthService,
    private mailService: MailService,
    private store: Store<AppState>,
    private translate: TranslateService
  ) {
    this.perimeterId = history?.state?.perimeterId;
    this.mailInit = true;
    this.form = this.formBuilder?.group({
      userId: [],
      userName: [null, Validators.required],
      userLogin: [null, [Validators.required, Validators.minLength(2)]],
      userFirstName: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      rights: []
    });

    let role = this.authService.roleValue;
    if (role) {
      this.userService.getRightsUserByPerimeter(role?.perimeterId, role?.profileCode).then((res) => {
        this.userRights = res;
      });
    }
  }

  get formCrls() {
    return this.form?.controls;
  }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      history.state.userId = params.id;
      if (history.state.userId) {
        this.userService.get(history.state.userId).subscribe((user) => {
          this.currentItem = user;
          this.form.patchValue(user);
          this.form.controls.userLogin.disable();
        });
      } else {
        this.form.patchValue({});
      }
    });
  }

  majStore(snackbarMsgType: string) {
    this.userService.getAll().subscribe(
      (arr) => {
        if (arr) {
          //Ajouter la liste dans le store
          this.store.dispatch(new UpdateResourceAction(arr));
          this.snackbarService.open(snackbarMsgType);
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    );
  }

  //Cliquer sur le bouton enregistrer
  async clickSave(currentItem: User) {
    if (this.form.invalid) {
      return;
    }
    let rep;
    if (currentItem?.userId === null) {
      try {
        rep = await this.userService.add(currentItem);
      } catch {
        this.snackbarService.open(SnackbarTypes.error);
        return;
      }

      if (rep?.error) {
        this.snackbarService.showMessage(rep?.error);
        return;
      }

      this.mailInit = true;
      this.currentItem = rep;
      this.sendEmail();
      this.majStore(SnackbarTypes.add);
      this.router.navigate([SiteMapUrl.MenuUser, rep?.userId], { state: { perimeterId: this.perimeterId, userId: rep.userId } });
      return;
    }

    try {
      rep = await this.userService.update(currentItem);
    } catch {
      this.snackbarService.open(SnackbarTypes.error);
      return;
    }

    this.majStore(SnackbarTypes.update);
    this.form.patchValue(rep);
  }

  clickResetPassword() {
    this.mailInit = false;
    this.sendEmail();
  }

  sendEmail() {
    const formData = this.form.value;
    var listRecipient: string[];

    var userEmail = '';
    if (this.currentItem?.email != null && this.currentItem?.userId != null) userEmail = this.currentItem?.email;

    this.mailService.sendMail(this.currentItem?.userId, this.mailInit == false ? MailTemplates.ResetPassword : MailTemplates.CreateAccount, true).subscribe(
      () => {
        if (this.mailInit == false) {
          this.snackbarService.open(SnackbarTypes.mailReinitPasswordSend);
        } else {
          this.snackbarService.open(SnackbarTypes.mailInitSend);
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
      }
    );
  }

  deleteRight(i: number, arr: UserRight[]) {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_right') }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (!result) return;

      let res;
      try {
        res = await this.userService.deleteUserRight(this.formCrls?.userId?.value, arr[i]?.rightId);
      } catch {
        this.snackbarService.open(SnackbarTypes.error);
        return;
      }

      if (!res) {
        this.snackbarService.open(SnackbarTypes.error);
        return;
      }

      arr.splice(i, 1);
      this.snackbarService.open(SnackbarTypes.delete);
    });
  }

  async addRight(arr?: UserRight[]) {
    const dialogRef = this.dialog.open(DialogRightUserComponent, {
      data: {
        selectedRight: {},
        userRights: this.userRights
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (!result) return;

      let right;
      try {
        right = await this.userService.addUserRight(this.formCrls?.userId?.value, result);
      } catch {
        this.snackbarService.open(SnackbarTypes.error);
        return;
      }

      if (!right) {
        this.snackbarService.open(SnackbarTypes.error);
        return;
      }

      result.rightId = right?.rightId;
      arr?.splice(0, 0, result);
      this.snackbarService.open(SnackbarTypes.add);
    });
  }

  openDialogDelete(resourceId?: string): void {
    const dialogRef = this.dialog.open(DialogOverviewComponent, {
      data: { title: this.translate.instant('confirm_delete_user') }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.delete(resourceId);
      }
    });
  }

  delete(userId?: string) {
    if (userId) {
      this.userService.delete(userId).subscribe({
        next: (data) => {
          this.majStore(SnackbarTypes.delete);
          this.router.navigate([SiteMapUrl.MenuUser]);
        },
        error: (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          console.error(error);
        }
      });
    }
  }
}
